import React, { useEffect, useState } from 'react';

import Creators from '../../components/creators/Creators';
import { ACTIONS } from '../../constants/logs';
import LogService from '../../services/log.service';
import useBlocRef from '../../utils/useBlocRef.hook';
import ResendInvite from '../resendInvite/ResendInvite';

const defaultCriteria = {
  limit: 10,
  orderField: null,
  orderType: 'ASC',
  page: 0,
};

export default () => {
  const blocRef = useBlocRef('creatorsBloc');
  const [creators, setCreators] = useState(blocRef.current.creators$.getValue());
  const onInvitedClick = (creator) => {
    blocRef.current.openResendInvite(creator, ResendInvite);
  };

  useEffect(() => {
    const sub = blocRef.current.creators$.subscribe(setCreators);

    return () => {
      sub.unsubscribe();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      blocRef.current.dispose();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCriteriaChange = async (criteria) => {
    const updatedCriteria = {
      ...defaultCriteria,
      ...criteria,
    };

    blocRef.current.updateSearchCriteria(updatedCriteria);

    new LogService().create({
      action: ACTIONS.CREATORS_VIEWED,
      details: {
        Amount: updatedCriteria?.limit || 10,
        Page: updatedCriteria?.page + 1,
      },
    });
  };

  return <Creators onInvitedClick={onInvitedClick} onCriteriaChange={onCriteriaChange} creators={creators && creators.data} total={creators && creators.total} />;
};
